export default function formatBoolean(v) {
  if (v == null) {
    return v;
  }

  return v ? "Ja" : "Nej";
}
